<div class="user-search-container noselect">
  <div class="search-input-wrapper" cdkOverlayOrigin #origin="cdkOverlayOrigin" #originEl>
    <input
      type="text"
      class="search-input"
      [(ngModel)]="searchTerm"
      [placeholder]="placeholder"
      (focus)="onInputFocus()"
      (input)="onInputChange()"
      autocomplete="off"
    />
    <button
      *ngIf="selectedUser"
      type="button"
      class="clear-button"
      (click)="clearSelection()"
    >
      <span class="fa-solid fa-xmark"></span>
    </button>
    <span class="dropdown-icon">
      <span class="fa-solid fa-chevron-down"></span>
    </span>
  </div>

  <!-- Rendered in the CDK overlay container on <body> so host scroll containers
       (e.g. a modal body) cannot clip or absorb the list. -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayWidth]="triggerWidth"
    [cdkConnectedOverlayPositions]="dropdownPositions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (overlayOutsideClick)="onOutsideClick($event)"
    (overlayKeydown)="onOverlayKeydown($event)"
    (detach)="isDropdownOpen = false"
  >
    <div class="dropdown-menu">
      <div *ngIf="isLoading" class="loading-state">
        <span class="spinner-small"></span> Loading users...
      </div>

      <div *ngIf="!isLoading && filteredUsers.length === 0" class="empty-state">
        No users found
      </div>

      <div *ngIf="!isLoading && filteredUsers.length > 0" class="dropdown-list">
        <div
          *ngFor="let user of filteredUsers"
          class="dropdown-item"
          [class.selected]="selectedUser?.userId === user.userId"
          (click)="selectUser(user)"
        >
          <div class="user-email">{{ user.email }}</div>
          <div class="user-name" *ngIf="user.firstName || user.lastName">
            {{ user.firstName }} {{ user.lastName }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
